import { applicationTrustApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const TRUST_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/trust`,
  {
    GET_TRUST_INFO: 'GET_TRUST_INFO',
    EDIT_TRUST_INFO: 'EDIT_TRUST_INFO',
    DELETE_TRUST_INFO: 'DELETE_TRUST_INFO',
  },
);

export const getTrustInfoAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationTrustApi.getTrust(params);

  return dispatch({
    type: TRUST_ACTION_TYPE.GET_TRUST_INFO,
    payload: data,
  });
});

export const editTrustInfoAction = params => async dispatch => {
  const { data } = await applicationTrustApi.editTrust(params);

  return dispatch({
    type: TRUST_ACTION_TYPE.EDIT_TRUST_INFO,
    payload: data,
  });
};

export const deleteTrustInfoAction = params => async dispatch => {
  const { data } = await applicationTrustApi.deleteTrust(params);

  return dispatch({
    type: TRUST_ACTION_TYPE.DELETE_TRUST_INFO,
    payload: data,
  });
};
